// extracted by mini-css-extract-plugin
module.exports = {"nav__search-input":"NavSearchInput_nav__search-input__bwreZ","nav__search-clear-btn":"NavSearchInput_nav__search-clear-btn__jAgpt"};